import { CommentVI } from "./comment/vi";
import { EditorVI } from "./editor/vi";
import { DocumentVI } from "./document/vi";
import { ActionBarVI } from "./action-bar/vi";
import { TimeKeepingVI } from "./layout/setting/timekeeping/vi";

export const CommonVI = {
  common: {
    noExists: "Không tồn tại",
    noData: "Chưa có dữ liệu",
    description: "Mô tả",
    btn: {
      delete: "Xóa",
      cancel: "Hủy bỏ",
      no: "Không",
    },
    empty: {
      record: "bản ghi",
      shiftWork: "dữ liệu phân ca",
      timekeeping: "dữ liệu chấm công",
      shiftAssignment: "phân ca làm việc",
      autoTimeKeeping: "chấm công tự đông",
      leave: "dữ liệu nghỉ phép",
      payroll: "dữ liệu bảng lương",
      payrollConfig: "cấu hình bảng lương",
      payrollCustom: "bảng lương tùy chỉnh",
      shiftConfig: "ca làm việc",
      leaveConfig: "cấu hình nghỉ phép",
      locationCheckIn: "cấu hình vị trí chấm công",
      notFoundRecord: "Hiện tại không có {{module}} nào. ",
      click: "Nhấn vào đây để",
      searchEmpty: "  không khớp với bất kỳ {{title}} nào.",
      tryAgain: "Vui lòng thử lại",
    },

    goBackModal: "Bạn có muốn giữ lại trang sau khi thực hiện thành công?",

    required: "là trường bắt buộc!",
    showAgain: "Không hiển thị lại",
    all: "Tất cả",

    add: "Tạo mới",
    update: "Cập nhật",
    import: "Import",
    importAndSave: "Import và lưu cấu hình",
    delete: "Xóa",
    recall: "Thu hồi",
    recallConfirm:
      "Bạn có chắc chắn là muốn thu hồi {{module}} {{name}} không ?",
    confirm_action: "Bạn có chắc chắn là muốn {{action}} {{module}} không?",
    youHave: "Bạn đã",
    title_confirm: "Xác nhận ",
    shift: "phân ca",
    payroll: "bảng lương",
    success: "thành công",
    recallMessage: "Bạn đã gửi yêu cầu thu hồi thành công!",
    create: "Tạo mới",
    cancel: "Hủy",
    yes: "Có",
    agree: "Đồng ý",
    no: "Không",
    addField: "Thêm trường",
    addAndSend: "Tạo và gửi",
    updateAndSend: "Cập nhật và gửi",
    enable: "Cho phép",
    disable: "Không cho phép",
    approvalButton: "Duyệt",
    back: "Quay về",
    backHome: "Quay về trang chủ ",
    title403: "Bạn không có quyền truy cập trang !",
    title404: "Trang truy cập không tồn tại !",
    title500:
      "Đã có lỗi xảy ra , chúng tôi sẽ sớm khắc phục. Vui lòng thử lại sau !",
    default: "mặc định",

    validate: {
      required: "được yêu cấu",
    },
    draft: "Bản nháp",
    pending: "Chờ thực hiện",
    completed: "Hoàn thành",
    doing: "Đang thực hiện",
    approved: "Đã duyệt",
    actived: "Hoạt động",
    inactive: "Tạm dừng",
    inactived: "Không hoạt động",
    denied: "Hủy",
    trashed: "Đã xóa",
    active: "Hoạt động",
    activing: "Đang hoạt động",
    expired: "Hết hiệu lực",
    incomplete: "Chưa hoàn thành",
    unevaluated: "Chờ đánh giá",
    evaluated: "Đã đánh giá",
    storage: "Lưu trữ",
    status: "Trạng thái",
    changed: "Thay đổi",

    message: {
      add: "Tạo mới thành công",
      update: "Cập nhật thành công",
      delete: "Xóa thành công",
      deleteAsk: "Bạn có chắc chắn muốn xóa ",
    },
    labelCurrent: {
      null: "Không tồn tại",
    },

    timeKeeping: {
      otherJobTitle: "Khác (Nhân viên không có vị trí )",
      dayWork: "công",
      checkinWork: "Chấm công",
      day: "ngày",
      sumDayWork: "Tổng công",
      sumWorkHour: "Tổng giờ làm",
      workHour: "Giờ làm",
      night: "ban đêm",
      workDay: "ban ngày",
      checkinFingerprint: "Chốt vân tay",
      workHourValid: "Giờ làm được tính",
      workHourCompensatory: "Giờ được tính nghỉ bù",
      overtimeCompensatory: "Thời gian làm thêm được tính cho nghỉ bù",
      leaveFrom: "Xin nghỉ từ",
      to: "đến",
      compensationDay: "Ngày đăng ký làm bù",
      reason: "Lý do",
      place: "Địa điểm",
      time: "Thời gian",
      fined: "Bị phạt",
      notFined: "Không bị phạt",
      late: "Đi muộn",
      leave: "Về Sớm",
      shift: "Ca",
      shiftWork: "Ca làm việc",
      shiftWorkLeave: "Ca xin nghỉ",
      shiftWorkCompensatory: "Công sẽ được cộng vào ngày làm bù tương ứng",
      sumWorkInDay: "Tổng công trong ngày",
      checkinFingerprintInDay: "Danh sách chấm vân tay trong ngày",
      notCheckinFingerprint: "Không chấm vân tay trong ngày",
      shiftWorkInDay: "Các ca làm việc trong ngày",
      countHour: "Số giờ",
      countShift: "Số công",
      checkin: "Chốt vào",
      workUnit: "Công làm việc",
      calWorkDay: "Công thực tế",
      numberWorkdayAuto: "Công chuẩn",
      calWorkHour: "Giờ làm việc thực tính",
      countNumberWorkdayAuto: "Số công chuẩn",
      countLate: "Số lần đi muộn",
      countLeave: "Số lần về sớm",
      lateMinute: "Số phút đi muộn",
      leaveMinute: "Số phút về sớm",
      calWorkdayLeaveNoReason: "Số công nghỉ không lý do",
      noCheckInOut: "Số lần quên check in/out",
      calWorkHourNight: "Giờ làm việc thực tính ban đêm",
      calWorkHourLight: "Giờ làm việc thực tính ban ngày",
      calWorkHourOverTime: "Giờ làm thêm thực tế",
      workdayOverTime: "Công làm thêm thực tế",
      calMealDayOvertime: "Công ăn làm thêm",
      calMealDayShift: "Công ăn theo ca",
      calMealDay: "Công ăn",
      calFineLate: "Tiền phạt đi muộn",
      calFineLeave: "Tiền phạt về sớm",
      calFineLeaveNoReason: "Tiền phạt nghỉ không lý do",
      calFineNoCheckInOut: "Tiền phạt quên check inout",
      calFine: "Tiền phạt chấm công",
      calWorkLate: "Công phạt đi muộn",
      calWorkdayLeave: "Công phạt về sớm",
      countCalWorkdayLeaveNoReason: "Công phạt nghỉ không lý do",
      calWorkdayNoCheckInOut: "Công phạt quên check inout",
    },
  },
  ...CommentVI,
  ...EditorVI,
  ...DocumentVI,
  ...ActionBarVI,
  ...TimeKeepingVI,
};
